export default {
  questionsThemes: state => state.questionsThemes,
  errors: state => state.errors
};
